import * as React from 'react';
import * as commonStyles from './common.module.scss';
import SecondaryButton from './secondary-button';
import TertiaryButton from './tertiary-button';

interface Props {
  title: string;
  message: string;
  confirmAction: () => void;
  cancelAction: () => void;
}

const ConfirmationDialog = ({ title, message, confirmAction, cancelAction }: Props) => {
  return (
    <div className={commonStyles.dialogContainer}>
      <div>
        <div className={`${commonStyles.dialogHeader}`}>
          <h1>{title}</h1>
        </div>
        <span className="body2">{message}</span>
      </div>
      <div className={commonStyles.dialogButtonContainer}>
        <div className={commonStyles.buttonContainer}>
          <SecondaryButton text="Yes" title="Yes" handleClick={() => confirmAction()} />
        </div>
        <div className={commonStyles.buttonContainer}>
          <TertiaryButton
            text="No"
            title="No"
            handleClick={() => {
              cancelAction();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
